import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { Logger } from "infra/logger/logger";
import roleRepository from "infra/repositories/role-repository";

export const useRoleByFilter = (filter: BaseInputFilter) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["roles"],
    queryFn: async () => {
      try {
        const result = await roleRepository.getAll(filter);
        return result;
      } catch (error: any) {
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: Number(process.env.REACT_APP_QUERY_STALE_TIME_SHORT) || 0,
  });
};
